import { Button, ButtonTitle, ButtonIcon } from '@systhemaui/react'

import { faArrowRightToBracket, faUser } from '@fortawesome/free-solid-svg-icons'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

function constructFaSvg(icon: IconDefinition) {
  if (!icon || !icon.icon || !icon.icon[0] || !icon.icon[1] || !icon.icon[4]) {
    return ''
  }

  const viewBox = `${icon.icon[0]} ${icon.icon[1]}`
  const path = icon.icon[4]

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewBox}"><path fill="currentColor" d="${path}"/></svg>`
}

interface HeaderCtaProps {
  initialSignedIn?: boolean
  userName?: string
}

export default function HeaderCta({ initialSignedIn = false, userName }: HeaderCtaProps) {
  const signedIn = initialSignedIn

  if (signedIn) {
    return (
      <Button.a
        href="/profil-beallitasok"
        variant="secondary"
        className="max-md:size-8 max-md:items-center max-md:justify-center max-md:border-0 max-md:bg-transparent max-md:p-0 max-md:text-white"
      >
        <ButtonTitle className="max-md:hidden">{userName || 'Profil'}</ButtonTitle>
        <ButtonIcon
          className="max-md:inline-block max-md:size-6 max-md:content-center max-md:text-center max-md:*:size-5"
          dangerouslySetInnerHTML={{ __html: constructFaSvg(faUser) }}
        />
      </Button.a>
    )
  }
  return (
    <Button.a
      href="/belepes"
      className="max-md:size-8 max-md:items-center max-md:justify-center max-md:border-0 max-md:bg-transparent max-md:p-0 max-md:text-white"
    >
      <ButtonTitle className="max-md:hidden">Belépés</ButtonTitle>
      <ButtonIcon
        className="max-md:inline-block max-md:size-6 max-md:content-center max-md:text-center max-md:*:size-5 max-md:**:fill-white"
        dangerouslySetInnerHTML={{ __html: constructFaSvg(faArrowRightToBracket) }}
      />
    </Button.a>
  )
}
